import auth from './auth.js';
import { initCognitoSsoEnv } from '../../../packages/src/cognito-sso/index.js';
import { initEnvValue } from '../../../packages/src/envs/index.js';

// index.html is a redirect-only entry point and does not load the shared UI bundle.
initCognitoSsoEnv(initEnvValue);

const domainWithEnabledLogin = [
  'localhost',
  'dev-photo.occo.io',
  'prelive-photo.occo.io',
  'photo.occo.io',
  'photo.ph0.cc',
  'testing-photo.occo.io',
];

function getQueryVariable(variable) {
  const query = window.location.search.substring(1);
  const vars = query.split('&');
  for (let i = 0; i < vars.length; i += 1) {
    const pair = vars[i].split('=');
    if (pair[0] === variable) {
      return decodeURI(pair[1]);
    }
  }
  return false;
}

function isQueryVariableExist(variable) {
  return getQueryVariable(variable) !== false;
}

/**
 * Backward compatibility with old shared links that land on index.html with query params.
 */
function redirectFromOldPages() {
  if (isKioskPage()) {
    redirectTo(replacePage('kioskStore/kiosk-page.html'));
  } else if (isRideKiosk()) {
    redirectTo(replacePage('ride-kiosk.html'));
  } else if (isOldWebapp()) {
    redirectTo(replacePage('old-webapp.html'));
  } else if (isKioskAlbumLink()) {
    redirectTo(replacePage('kiosk-album-link.html'));
  } else if (isPublicPage()) {
    redirectTo(replacePage('public-page.html'));
  } else if (isPrivatePage()) {
    redirectTo(replacePage('private-page.html'));
  }

  function isKioskPage() {
    return isQueryVariableExist('kType') && getQueryVariable('kType') !== 'evSB3';
  }

  function isOldWebapp() {
    return !isQueryVariableExist('kType') && isQueryVariableExist('attId');
  }

  function isRideKiosk() {
    return getQueryVariable('kType') === 'evSB3';
  }

  function isKioskAlbumLink() {
    return isQueryVariableExist('pId') && isQueryVariableExist('kioskMode');
  }

  function isPublicPage() {
    return isQueryVariableExist('pId');
  }

  function isPrivatePage() {
    return isQueryVariableExist('pvId');
  }

  function replacePage(page) {
    const currentURL = new URL(window.location.href);
    const arrayPath = currentURL.pathname.split('/');
    arrayPath[arrayPath.length - 1] = page;
    currentURL.pathname = arrayPath.join('/');
    return currentURL.href;
  }

  function redirectTo(url) {
    window.location.replace(url);
  }
}

// index.html is the SSO entry for bare URLs (like occo-admin). Any query string is handled
// by the legacy router first — same as before SSO, except bare index no longer jumps to
// admin-console (that path now goes through Cognito login).
const oauthParams = new URLSearchParams(window.location.search);
if (oauthParams.has('code') || oauthParams.has('error')) {
  auth.initLoginPage(true);
} else if (window.location.search === '') {
  if (domainWithEnabledLogin.includes(location.hostname)) {
    auth.initLoginPage(true);
  } else {
    location.href = 'page-not-found.html';
  }
} else {
  redirectFromOldPages();
}
